import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (paramBody) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });

    const Authorization = UserToken;
    const url = ApiUrl2 + 'config-holidays-edit';
    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };

    const response = await doFetch(url,argument);
    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : response.ok });
    return response;
};